module.exports = __webpack_public_path__ + "media/src/images/menus-128-9a59fee35e082b00100123058cf23ce1.png";